import type {
  FillLayerSpecification,
  GeoJSONSourceSpecification,
  LineLayerSpecification,
} from '@vis.gl/react-maplibre';

import IAA2025 from '@/assets/layers/IAA2025.json';
import Marathon2025 from '@/assets/layers/Marathon2025.json';
import TUMEvakuierungSort from '@/assets/layers/TUM_evakuierung_sort.json';
import Untersuchungsraum from '@/assets/layers/Untersuchungsraum.json';
import VorrangnetzBF from '@/assets/layers/vorangnetzBF.json';
import type { MapState } from '@/types/MapState';

export const LAYERS: Record<
  keyof MapState['layersControl'],
  {
    label: string;
    disabled?: boolean;
    source?: GeoJSONSourceSpecification;
    layer?: LineLayerSpecification | FillLayerSpecification;
  }
> = {
  levelOfService: { label: 'Verkehrslage', disabled: true },
  trafficReports: { label: 'Meldungen', disabled: true },
  parking: { label: 'Parken', disabled: true },
  marathon2025: {
    label: 'München Marathon (12.10.2025)',
    source: {
      type: 'geojson',
      promoteId: 'id',
      data: Marathon2025 as GeoJSONSourceSpecification['data'],
    },
    layer: {
      id: 'marathon2025',
      source: 'marathon2025-source',
      type: 'line',
      paint: {
        'line-color': 'rgb(0,10,110)',
        'line-width': ['case', ['boolean', ['feature-state', 'hover'], false], 4, 3],
        'line-opacity': ['case', ['boolean', ['feature-state', 'hover'], false], 0.8, 0.5],
      },
    },
  },
  iaa2025: {
    label: 'IAA Mobility (08.09.-12-09-2025)',
    source: {
      type: 'geojson',
      promoteId: 'fid',
      data: IAA2025 as GeoJSONSourceSpecification['data'],
    },
    layer: {
      id: 'iaa2025',
      source: 'iaa2025-source',
      type: 'line',
      paint: {
        'line-color': 'rgb(0,10,110)',
        'line-width': ['case', ['boolean', ['feature-state', 'hover'], false], 4, 3],
        'line-opacity': ['case', ['boolean', ['feature-state', 'hover'], false], 0.8, 0.5],
      },
    },
  },
  priorityNetworkFireDepartment: {
    label: 'Vorrangnetz Berufsfeuerwehr',
    source: {
      type: 'geojson',
      promoteId: 'OBJID',
      data: VorrangnetzBF as GeoJSONSourceSpecification['data'],
    },
    layer: {
      id: 'priorityNetworkFireDepartment',
      source: 'priorityNetworkFireDepartment-source',
      type: 'line',
      paint: {
        'line-color': [
          'case',
          ['==', ['get', 'NETZFUNK_1'], 'Hauptstraßennetz'],
          'rgb(255,90,90)',
          ['==', ['get', 'NETZFUNK_1'], 'Nebenstraßennetz'],
          'rgb(0,70,170)',
          '#0f71b8',
        ],
        'line-width': ['case', ['boolean', ['feature-state', 'hover'], false], 4, 3],
        'line-opacity': ['case', ['boolean', ['feature-state', 'hover'], false], 0.8, 0.5],
      },
    },
  },
  tumAudimaxEvacuation: {
    label: 'TUM Audimax Evakuierung',
    source: {
      type: 'geojson',
      promoteId: 'ID_EREIGNI',
      data: TUMEvakuierungSort as GeoJSONSourceSpecification['data'],
    },
    layer: {
      id: 'tumAudimaxEvacuation',
      source: 'tumAudimaxEvacuation-source',
      type: 'fill',
      paint: {
        'fill-color': [
          'case',
          ['==', ['get', 'layer'], 'Sperrbereich_Polygon_300m'],
          'rgb(255,210,108)',
          ['==', ['get', 'layer'], 'Sperrbereich_Polygon_500m'],
          'rgb(247,159,67)',
          ['==', ['get', 'layer'], 'Sperrbereich_Polygon_1000m'],
          'rgb(218,125,151)',
          'rgb(218,125,151)',
        ],
        'fill-opacity': ['case', ['boolean', ['feature-state', 'hover'], false], 0.7, 0.5],
        'fill-outline-color': 'white',
      },
    },
  },
  studyArea: {
    label: 'Untersuchungsgebiet (aktiv ab 03.07.2026)',
    source: {
      type: 'geojson',
      promoteId: 'id',
      data: Untersuchungsraum as GeoJSONSourceSpecification['data'],
    },
    layer: {
      id: 'studyArea',
      source: 'studyArea-source',
      type: 'fill',
      paint: {
        'fill-color': 'rgb(255,210,108)',
        'fill-opacity': ['case', ['boolean', ['feature-state', 'hover'], false], 0.7, 0.5],
      },
    },
  },
};
